/**
 * Whether the Inbox "Groups" tab is shown. WhatsApp groups exist only on QR numbers, so the tab needs all of:
 *   - the role may see groups (Owner, or Groups -> View),
 *   - the account is enabled for QR,
 *   - the CURRENT workspace has at least one QR number (a workspace with the official Meta number AND QR numbers counts: its
 *     groups live on the QR numbers; a Meta-only workspace, or an account without QR, has none).
 * A number that is logged out but still linked keeps the tab (its group history is still there); once the last number is removed
 * the tab goes, as its groups are hidden too.
 */
export function shouldShowGroupsTab({ canViewGroups, workspace }) {
  if (!canViewGroups) return false;
  if (!workspace || !workspace.qrPilotEnabled) return false;
  return Array.isArray(workspace.whatsappQrConnections) && workspace.whatsappQrConnections.length > 0;
}
